module.exports = __webpack_public_path__ + "static/01-47b316a4e5333ef719433e78c5bcded4.jpg";